import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { visuallyHidden as _visuallyHidden } from '@guardian/src-foundations/accessibility';
import { supportingText } from './styles';
const visuallyHidden = css `
	${_visuallyHidden}
`;
export const SupportingText = ({ hideLabel, children, }) => {
    return (_jsx("p", Object.assign({ css: (theme) => [
            supportingText(theme.label && theme),
            hideLabel ? visuallyHidden : '',
        ] }, { children: children }), void 0));
};
//# sourceMappingURL=SupportingText.js.map
